import Chart from 'chart.js/auto'
import 'chartjs-adapter-moment'

export default function chart() {
    if (!document.getElementById('perfChart')) {
        return
    }

    const chartCanvas = document.getElementById('perfChart')
    const gradient = chartCanvas.getContext('2d').createLinearGradient(0, 0, 0, 400)
    gradient.addColorStop(0.5, 'rgba(233, 85, 20, 0.2)')
    gradient.addColorStop(1, 'rgba(233, 85, 20, 0.05)')
    Chart.defaults.color = '#BEBEBE'

    const navPerShareData = JSON.parse(chartCanvas.dataset.navPerShare)
    const sharePricesData = JSON.parse(chartCanvas.dataset.sharePrices)

    const settings = {
        type: 'line',
        data: {
            datasets: [
                {
                    data: sharePricesData,
                    label: chartCanvas.dataset.sharePricesLabel,
                    borderColor: '#1C88C8',
                    pointBackgroundColor: '#1C88C8',
                    pointStyle: false,
                },
                {
                    data: navPerShareData,
                    backgroundColor: gradient,
                    label: chartCanvas.dataset.navPerShareLabel,
                    fill: 'start',
                    borderColor: '#E95514',
                    pointBackgroundColor: '#E95514',
                    pointStyle: false,
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom',
                    usePointStyle: false,
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        pointStyleWidth: 42,
                        boxHeight: 7,
                    },
                },
            },
            scales: {
                x: {
                    type: 'time',
                    time: {
                        unit: 'year',
                    },
                    ticks: {
                        stepSize: 1,
                        callback: function(value) {
                            const date = new Date(value)
                            if (date.getMonth() === 0) {
                                return date.toLocaleString('default', { month: 'short', year: 'numeric' })
                            }
                            return ''
                        },
                    },
                },
                y: {
                    grid: {
                        color: 'rgba(69, 71, 77, 1)',
                    },
                },
            },
        },
    }
    return new Chart(document.getElementById('perfChart'), settings)
}
